// extracted by mini-css-extract-plugin
module.exports = {"quoteContainer":"Quote_quoteContainer__3GbB6","quoteButtonContainer":"Quote_quoteButtonContainer__3nv1Q","staticTextStyle":"Quote_staticTextStyle__2hcSc"};